import type Owner from '@ember/owner';
import { schedule } from '@ember/runloop';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import BoardMobileComponent from 'webapp/components/board/mobile';
import LayoutDesignerBoardSettingsComponent from 'webapp/components/layout-designer/board-settings';
import type DesignerController from 'webapp/controllers/designer';

import type Board from 'webapp/models-custom/board';
import type BoardLoop from 'webapp/models-custom/board-loop';
import type BoardState from 'webapp/models-custom/board-state';

interface Args {
	board: Board;
	boardState: BoardState;
	designerController: DesignerController;
	onSave: () => void;
	onDelete: () => void;
	onCopy: () => void;
	onLoopChange: (boardLoop: BoardLoop) => void;
	onInit: () => void;
}

export default class DesignerBoardMobileComponent extends Component<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		schedule('afterRender', () => {
			this.args.onInit();
		});
	}

	get currentZoom(): number {
		return this.currentUserService.mobileBoardZoom;
	}

	get width(): number {
		const baseWidth = 300;
		return (baseWidth * this.currentZoom) / 100;
	}

	get ctStyle() {
		return htmlSafe(`width:${this.width}px;`);
	}

	get templateClass(): string {
		let templateClass = '';

		if (this.args.board?.isAccountTemplate) {
			templateClass = 'is-template';

			if (this.currentZoom < 120) {
				templateClass += ' is-template--small';
			}
		}

		return templateClass;
	}
	<template>
		<div id="designer-board-ct--mobile" class={{this.templateClass}} style={{this.ctStyle}}>

			<LayoutDesignerBoardSettingsComponent
				@model={{@board}}
				@width={{this.width}}
				@currentZoom={{this.currentZoom}}
				@onBoardUpdate={{@onSave}}
				@onBoardDelete={{@onDelete}}
				@onBoardCopy={{@onCopy}}
				@onLoopChange={{@onLoopChange}}
				@designerController={{@designerController}}
			/>

			<BoardMobileComponent
				@boardState={{@boardState}}
				@isInDesigner={{true}}
				@currentZoom={{this.currentZoom}}
				@onSave={{@onSave}}
				@onDelete={{@onDelete}}
				@onCopy={{@onCopy}}
			/>

		</div>
	</template>
}
